"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SunnyQuarryRedeemerErrors = exports.SunnyQuarryRedeemerJSON = void 0;
const anchor_contrib_1 = require("@saberhq/anchor-contrib");
exports.SunnyQuarryRedeemerJSON = {
    version: "0.0.0",
    name: "sunny_quarry_redeemer",
    instructions: [
        {
            name: "createRedeemer",
            accounts: [
                {
                    name: "redeemer",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "iouMint",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "redemptionMint",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "redemptionVault",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "payer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "systemProgram",
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "bump",
                    type: "u8",
                },
            ],
        },
        {
            name: "redeemTokens",
            accounts: [
                {
                    name: "redeemer",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "tokens",
                    accounts: [
                        {
                            name: "iouMint",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "redemptionMint",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "redemptionVault",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "tokenProgram",
                            isMut: false,
                            isSigner: false,
                        },
                    ],
                },
                {
                    name: "sourceAuthority",
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: "iouSource",
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: "redemptionDestination",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "amount",
                    type: "u64",
                },
            ],
        },
        {
            name: "redeemTokensFromMintWrapper",
            accounts: [
                {
                    name: "redeemCtx",
                    accounts: [
                        {
                            name: "redeemer",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "tokens",
                            accounts: [
                                {
                                    name: "iouMint",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "redemptionMint",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "redemptionVault",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "tokenProgram",
                                    isMut: false,
                                    isSigner: false,
                                },
                            ],
                        },
                        {
                            name: "sourceAuthority",
                            isMut: false,
                            isSigner: true,
                        },
                        {
                            name: "iouSource",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "redemptionDestination",
                            isMut: true,
                            isSigner: false,
                        },
                    ],
                },
                {
                    name: "mintWrapper",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "mintWrapperProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minter",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: "amount",
                    type: "u64",
                },
            ],
        },
        {
            name: "redeemAllTokensFromMintWrapper",
            accounts: [
                {
                    name: "redeemCtx",
                    accounts: [
                        {
                            name: "redeemer",
                            isMut: false,
                            isSigner: false,
                        },
                        {
                            name: "tokens",
                            accounts: [
                                {
                                    name: "iouMint",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "redemptionMint",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "redemptionVault",
                                    isMut: true,
                                    isSigner: false,
                                },
                                {
                                    name: "tokenProgram",
                                    isMut: false,
                                    isSigner: false,
                                },
                            ],
                        },
                        {
                            name: "sourceAuthority",
                            isMut: false,
                            isSigner: true,
                        },
                        {
                            name: "iouSource",
                            isMut: true,
                            isSigner: false,
                        },
                        {
                            name: "redemptionDestination",
                            isMut: true,
                            isSigner: false,
                        },
                    ],
                },
                {
                    name: "mintWrapper",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "mintWrapperProgram",
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: "minter",
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [],
        },
    ],
    accounts: [
        {
            name: "Redeemer",
            type: {
                kind: "struct",
                fields: [
                    {
                        name: "bump",
                        type: "u8",
                    },
                    {
                        name: "iouMint",
                        type: "publicKey",
                    },
                    {
                        name: "redemptionMint",
                        type: "publicKey",
                    },
                    {
                        name: "redemptionVault",
                        type: "publicKey",
                    },
                ],
            },
        },
    ],
    events: [
        {
            name: "RedeemTokensEvent",
            fields: [
                {
                    name: "user",
                    type: "publicKey",
                    index: true,
                },
                {
                    name: "iouMint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "destinationMint",
                    type: "publicKey",
                    index: false,
                },
                {
                    name: "amount",
                    type: "u64",
                    index: false,
                },
            ],
        },
    ],
    errors: [
        {
            code: 300,
            name: "Unauthorized",
            msg: "Unauthorized.",
        },
    ],
};
exports.SunnyQuarryRedeemerErrors = (0, anchor_contrib_1.generateErrorMap)(exports.SunnyQuarryRedeemerJSON);
//# sourceMappingURL=sunny_quarry_redeemer.js.map